<template>
  <section class="layout-pt-lg layout-pb-lg">
    <div class="container">
      <div class="row justify-center">
        <div class="col-auto">
          <div v-html="vars.titleHtml"></div>
        </div>
      </div>
      
      <div class="row y-gap-30 pt-60 md:pt-30">
        <div class="col-12">
          <div class="table -type-1">
            <table>
              <thead>
                <tr>
                  <td>FEATURE</td>
                  <td>LET SIMPLE</td>
                  <td>FULLY MANAGED</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(description, index) in descriptions" :key="index">
                  <td>{{ description.feature }}</td>
                  
                  <!-- LET SIMPLE -->
                  <td class="lowlight" style="position: relative;">
                    <div style="display: flex; align-items: center; white-space: nowrap;">
                      <div 
                        v-if="icons[description.iconsimple]" 
                        v-html="icons[description.iconsimple]" 
                        style="width: 20px; height: 20px; min-width: 20px; display: flex; justify-content: center; align-items: center; margin-right: 8px;"
                      ></div>
                      {{ description.simple }}
                    </div>
                  </td>
                  
                  <!-- FULLY MANAGED -->
                  <td :style="`background-color: var(--c-${vars.backgroundColor})`" style="position: relative;">
                    <div style="display: flex; align-items: center; white-space: nowrap;">
                      <div 
                        v-if="icons[description.iconmanage]" 
                        v-html="icons[description.iconmanage]" 
                        style="width: 20px; height: 20px; min-width: 20px; display: flex; justify-content: center; align-items: center; margin-right: 8px;"
                      ></div>
                      {{ description.manage }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#app'
import { ComponentMixin } from '~/mixins/component.mixin'
import BlockSymbol from '~/components/common/BlockSymbol.vue'

export default defineNuxtComponent({
  name: 'TakeAction',

  components: {
    BlockSymbol
  },

  mixins: [ComponentMixin],

  computed: {
   
    descriptions() {
      return this.groupedVariables?.descriptions || []
    },
    items() {
      return this.groupedVariables.items || []
    }
  },

  data() {
    return {
      
      icons: {
        1: `
          <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.55156 12.5016L0.851562 6.80156L2.27656 5.37656L6.55156 9.65156L15.7266 0.476562L17.1516 1.90156L6.55156 12.5016Z" fill="#666666"/>
          </svg>
        `,
        2: `
          <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.55156 12.5016L0.851562 6.80156L2.27656 5.37656L6.55156 9.65156L15.7266 0.476562L17.1516 1.90156L6.55156 12.5016Z" fill="black"/>
          </svg>
        `,
        3: `
          <svg width="14" height="3" viewBox="0 0 14 3" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 2.49609H0V0.496094H14V2.49609Z" fill="#666666"/>
          </svg>
        `,
        4: `
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.4 14.5L0 13.1L5.6 7.5L0 1.9L1.4 0.5L7 6.1L12.6 0.5L14 1.9L8.4 7.5L14 13.1L12.6 14.5L7 8.9L1.4 14.5Z" fill="#666666"/>
          </svg>
        `
      }
    }
  } 

}) 
</script>

<style scoped>
.lowlight {
  color: #666;
}
.highlight {
 background-color: #666;
}
.table.-type-1 table thead {
    color: white;
    background-color: var(--primary);
    }
    .table.-type-1 table {

  border-collapse: collapse;
}


.table.-type-1 table thead td:not(:last-child) {
  border-right: 2px solid rgba(255,255,255,1);
}



  
</style>

